import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  height: 300px;

  h4 {
    margin-bottom: 0;
  }

  .alert-description-card {
    .ant-card-body {
      overflow: scroll;
      height: 80%;
    }
  }

  .active-event {
    background-color: #f1f7ff;
  }

  .ant-card-body {
    padding: 5px 24px;
  }

  .ant-card-head {
    border-bottom: 0;
    min-height: 40px;
  }

  .ant-descriptions {
    tr.ant-descriptions-row:nth-child(odd) th {
      padding-bottom: 0;
    }

    tr.ant-descriptions-row:nth-child(even) .ant-descriptions-item-container {
      margin-top: -5px;
    }
  }
`;

export const AlertTitle = styled.h4`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
`;

/**
 * AI AlertExpendedInfo styled components - expanded mode
 */
export const InfoContainer = styled.div`
  margin: 5px;
  background-color: #fff;
  border-radius: 4px;
`;

export const InfoHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin: 0 10px;
  border-bottom: 1px solid #e3e9f4;
  font-size: 18px;
  color: #313131;
`;

export const InfoHeadContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoAlertID = styled.span`
  padding-right: 10px;
  border-right: 1px solid #e3e9f4;
`;

export const InfoAlertMetric = styled.span`
  padding: 0 10px;
`;

export const InfoAlertMetricCollapse = styled.span`
  display: inline-block;
  padding: 0 10px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const InfoAlertBody = styled.div`
  @media (max-width: 1480px) {
    flex-direction: column;
  }

  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

export const InfoAlertSectionTitle = styled.div`
  display: flex;
  font-size: 14px;
  color: #5d5d5d;
`;

export const InfoAlertSectionRootCauseTitle = styled.div`
  font-size: 14px;
  color: #5d5d5d;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const InfoAlertDetailSection = styled.div`
  @media (max-width: 1480px) {
    width: 100%;
  }

  width: 60%;
`;

export const InfoAlertDetailAllItems = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InfoAlertDetailItem = styled.div`
  width: calc(25% - 10px);
  background-color: #f3f3f3;
  border-radius: 4px;
  padding: 6px 10px;
`;

export const InfoAlertCohortSection = styled.div`
  @media (max-width: 1480px) {
    width: 100%;
  }

  width: calc(40% - 10px);
  display: flex;
  flex-direction: column;
`;

export const InfoAlertCohortSectionBody = styled.div`
  display: flex;
  flex: 1;
  background-color: #f3f3f3;
  border-radius: 4px;
  padding: 6px 10px;
`;

export const InfoAlertCohortItem = styled.div`
  padding-right: 20px;
`;

export const InfoAlertValue = styled.div`
  font-size: 24px;
  color: #242424;
`;

export const InfoAlertRootCauseValue = styled.div`
  font-size: 24px;
  color: #242424;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const InfoHeadCollapse = styled.span`
  cursor: pointer;
  color: #0046ff;
  font-size: 16px;
`;

/**
 * AI AlertExpendedInfo styled components - collapsed mode
 */
export const CollapsedAlertInfo = styled.div`
  background-color: #fff;
  border-radius: 8px;
  height: 300px;
`;

export const CollapsedInfoLine = styled.div`
  display: flex;
`;

export const CollapseInfoAlertDetailItem = styled.div`
  padding: 6px 10px;
  width: 50%;
`;

export const CollapseInfoAlertValue = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #242424;
`;

export const CollapseInfoAlertSectionTitle = styled.div`
  padding: 6px 10px 0;
  font-size: 14px;
  color: #5d5d5d;
`;

export const CollapseInfoAlertCohortSectionBody = styled.div`
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const CollapseInfoAlertRootCause = styled.span`
  font-size: 18px;
  font-weight: 500;
  color: #242424;
`;

export const HelpLinkInToolTip = styled.a`
  padding-left: 8px;
  cursor: pointer;
  color: #4080e2;
  text-decoration: underline;

  &:hover {
    color: #4080e2;
    text-decoration: underline;
  }
`;
